import React from "react";

// Mesma regra da busca no servidor: sem acento, sem maiúscula, cada palavra
// vale por si. "conceicao" acende "Conceição".
const semAcento = (texto) =>
  texto
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase();

// Marca no texto as palavras buscadas. A comparação é no texto normalizado,
// mas o que aparece é o original: `mapa` diz de onde veio cada caractere.
const TermoDestacado = ({ texto, termo }) => {
  const original = String(texto || "");
  const palavras = semAcento(String(termo || "").trim())
    .split(/\s+/)
    .filter(Boolean);

  if (!palavras.length) return original;

  let normalizado = "";
  const mapa = [];
  for (let i = 0; i < original.length; i += 1) {
    const pedaco = semAcento(original[i]);
    normalizado += pedaco;
    for (let j = 0; j < pedaco.length; j += 1) mapa.push(i);
  }

  // Liga cada caractere coberto por alguma palavra.
  const marcado = new Array(original.length).fill(false);
  palavras.forEach((palavra) => {
    let de = normalizado.indexOf(palavra);
    while (de >= 0) {
      for (let k = de; k < de + palavra.length; k += 1) marcado[mapa[k]] = true;
      de = normalizado.indexOf(palavra, de + palavra.length);
    }
  });

  const partes = [];
  let inicio = 0;
  for (let i = 1; i <= original.length; i += 1) {
    if (i === original.length || marcado[i] !== marcado[inicio]) {
      const pedaco = original.slice(inicio, i);
      partes.push(
        marcado[inicio] ? (
          <mark
            key={inicio}
            className="rounded-sm bg-primary/20 font-semibold text-foreground"
          >
            {pedaco}
          </mark>
        ) : (
          pedaco
        ),
      );
      inicio = i;
    }
  }

  return <>{partes}</>;
};

export default TermoDestacado;
